module.exports = __webpack_public_path__ + "img/cattunnel16.965b13d4.jpg";